import Aside from './Aside';

export default Aside;



// WEBPACK FOOTER //
// ./src/components/aside/index.js